export const getMimeType = (type) => {
    switch (type) {
        case 'Pdf':
            return 'application/pdf'
        case 'Bitmap':
            return 'image/bmp'
        case 'Gif':
            return 'image/gif'
        case 'Jpeg':
        case 'Jpg':
        case 'Jpe':
            return 'image/jpeg'
        case 'Png':
            return 'image/png'
        case 'Tiff':
        case 'Tif':
            return 'image/tiff'
        case 'Txt':
        case 'Text':
        default:
            return 'text/plain'
    }
}


// WEBPACK FOOTER //
// ./src/shared/utils/getMimeType.js